/**
 * @desc 调价
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.PrcocurementOrderWorkflowRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementOrder/adjustPrice`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
